type ColorDotSize = "sm" | "md" | "lg";

interface ColorDotProps {
  color: string;
  size?: ColorDotSize;
  className?: string;
}

const sizeStyles: Record<ColorDotSize, string> = {
  sm: "w-2 h-2",
  md: "w-3 h-3",
  lg: "w-4 h-4",
};

export function ColorDot({ color, size = "md", className = "" }: ColorDotProps) {
  return (
    <span
      className={`inline-block rounded-full flex-shrink-0 ${sizeStyles[size]} ${className}`}
      style={{ backgroundColor: color }}
    />
  );
}

export type { ColorDotProps };
